import {enableFormBack, handleApiForm, tokenInput} from "../forms";
import {confirmModal} from "../confirmModal";
import {closeModal, pathIs, url} from "../utilities";
import axios from "axios";
import Spinner from "../spinner";
import {toastAlert} from "../toastAlert";
import {dt_simple, findInTableRow, getClosestRow} from "../tables";
import {in_app} from "./index";
import * as $ from "jquery";

const FileDownload = require('js-file-download');

export const authorizations_page = () => {

    let body = $('body');

    let profileAuthorizationsTable = $("#profileAuthorizationsTable");
    let extended = $('input[name="extended"]').val() || false;

    const AUTHORIZATIONS_CHECKBOX_INDEX = 0;
    const AUTHORIZATIONS_DISTRICT_INDEX = 1 ;
    const AUTHORIZATIONS_HUNTER_INDEX =  2 ;
    const AUTHORIZATIONS_NUMBER_INDEX = 3 ;
    const AUTHORIZATIONS_TYPE_INDEX = 4;
    const AUTHORIZATIONS_DATES_INDEX = 5;
    const AUTHORIZATIONS_CREATED_AT_INDEX = 6;
    const AUTHORIZATIONS_ACTIONS_INDEX = 7;

    if (profileAuthorizationsTable.length > 0) {
        profileAuthorizationsTable.DataTable({
            stateSave: false,
            order: [0, 'desc'],
            columnDefs: [
                {
                    targets: [0],
                    type: 'natural',
                }
            ],
            filters: {
                columns: [
                    {index: extended ? 1 : 0,},
                    extended ? {index: 2} : {},
                    {
                        index: 4,
                        title: 'Data',
                        values: [
                            {
                                text: 'bieżące',
                                value: 'bieżące',
                                custom: (settings, data) => {
                                    data = data[3];

                                    let dateTo;

                                    if (data.includes('(')) {
                                        dateTo = moment(data.split('(')[1].split(')')[0], 'DD/MM/YYYY');
                                    } else {
                                        dateTo = moment(data.split(' - ')[1], 'DD/MM/YYYY');
                                    }
                                    let dateFrom = moment(data.split(' - ')[0], 'DD/MM/YYYY');
                                    let now = moment();

                                    return dateFrom.isSameOrBefore(now) && dateTo.isSameOrAfter(now);
                                }
                            },
                            {
                                text: 'nadchodzące',
                                value: 'nadchodzące',
                                custom: (settings, data) => {
                                    data = data[3];

                                    let dateFrom = moment(data.split(' - ')[0], 'DD/MM/YYYY');
                                    let now = moment();

                                    return dateFrom.isAfter(now);
                                }
                            },
                            {
                                text: 'zakończone',
                                value: 'zakończone',
                                custom: (settings, data) => {

                                    data = data[3];

                                    let dateTo;
                                    if (data.includes('(')) {
                                        dateTo = moment(data.split('(')[1].split(')')[0], 'DD/MM/YYYY');
                                    } else {
                                        dateTo = moment(data.split(' - ')[1], 'DD/MM/YYYY');
                                    }

                                    let now = moment();

                                    return dateTo.isBefore(now);
                                }
                            }
                        ]
                    }
                ]
            },
        });
    }

    let authorizationsTable = $("#authorizationsTable");
    if (authorizationsTable.length > 0) {
        const generateColumnDefs = () => {
            let columns = [];

            if(extended) {
                columns = [...columns,
                    {
                        targets: AUTHORIZATIONS_CHECKBOX_INDEX,
                        data: 'id',
                        render: (data, type, row) => {
                            return `<input ${row.deleted_at || row.expiry_date ? 'disabled' : ''} type="checkbox" class="form-check-input" name="authorization[]" value="${data}" />`;
                        }
                    },
                    {
                        targets: AUTHORIZATIONS_ACTIONS_INDEX,
                        data: null,
                        render: (data, type, row) => {
                            let buttons = [];

                            if(row.deleted_at === null) {
                                buttons = [...buttons,
                                    `
                                        <a data-bs-toggle="modal" data-bs-target="#animalsModal"
                                           class="btn btn-sm btn-primary btnAnimalsModal mb-1"
                                           data-animals="${url(`api/authorizations/${row.id}/animals`)}">
                                            <i class="fas fa-search"></i>
                                        </a>
                                        
                                        <a class="btn btn-sm btn-primary mb-1"
                                           target="_blank"
                                           href="${url(`app/authorizations/${row.id}/pdf`)}?preview=true">
                                            <i class="fa fa-file-pdf"></i>
                                        </a>
                                        
                                    `
                                ]
                                if(row.expiry_date === null) {

                                    if (!window._is_archival_season) {
                                        buttons = [...buttons,
                                            `

                                         <div class="btn-group">
                                            <a class="btn btn-sm btn-primary mb-1" href="${url(`app/authorizations/${row.id}/edit`)}">
                                                Edytuj
                                            </a>
                                        <button type="button"
                                                class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split mb-1"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                            <span class="visually-hidden">Toggle Dropdown</span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-lg-end">
                                            <li>
                                                <form class="returnAuthorizationForm" method="post" action="${url(`api/authorizations/return`)}">
                                                ${tokenInput()}
                                                    <input type="hidden" name="id" value="${row.id}">
                                                    <button class="dropdown-item">
                                                        Zwróć
                                                    </button>
                                                </form>
                                            </li>
                                            <li>
                                                <form class="deleteAuthorizationForm" method="post" action="${url(`api/authorizations/delete`)}">
                                                ${tokenInput()}
                                                    <input type="hidden" name="id" value="${row.id}">
                                                    <button class="dropdown-item">
                                                        Usuń
                                                    </button>
                                                </form>
                                            </li>
                                            <li class="dropdown-divider"></li>
                                            <li>
                                                <span title="${!row.user_email ? 'Myśliwy nie posiada wprowadzonego adresu e-mail' : ''}">
                                                    <button
                                                            ${!row.user_email ? 'disabled' : ''}
                                                            data-id="${row.id}"
                                                            data-email="${row.user_email}" type="button"
                                                            class="dropdown-item btnSendMail">
                                                            Wyślij w wiadomości email
                                                    </button>
                                                </span>
                                            </li>
                                            
                                        `
                                        ]
                                    }
                                }else{
                                    buttons = [...buttons,
                                        `
                                        <form class="restoreAuthorizationForm btn btn-sm p-0 mb-1" method="post" action="${url(`api/authorizations/restore`)}">
                                                ${tokenInput()}
                                                <input type="hidden" name="id" value="${row.id}">
                                                <button class="btn btn-sm btn-primary">
                                                    Przywróć
                                                </button>
                                        </form>
                                    `
                                    ]
                                }
                            }

                            return `<span class="text-nowrap">${buttons.join('')}</span>`
                        }
                    }
                ];
            }

            columns = [...columns,
                {
                    targets: AUTHORIZATIONS_CHECKBOX_INDEX,
                    data: 'id',
                    render: (data, type, row) => {
                        return `<input ${row.deleted_at || row.expiry_date ? 'disabled' : ''} type="checkbox" class="form-check-input" name="authorization[]" value="${data}" />`;
                    }
                },
                {
                    targets: AUTHORIZATIONS_DISTRICT_INDEX,
                    data: 'district'
                },
                {
                    targets: AUTHORIZATIONS_HUNTER_INDEX,
                    data: 'hunter'
                },
                {
                    targets: AUTHORIZATIONS_NUMBER_INDEX,
                    data: 'number',
                    'type': 'natural'
                },
                {
                    targets: AUTHORIZATIONS_TYPE_INDEX,
                    data: 'type'
                },
                {
                    targets: AUTHORIZATIONS_DATES_INDEX,
                    data: null,
                    render: (data, type, row) => {

                        let string;
                        if(row.expiry_date === null){
                            string = `${moment(row.from).formatPHP('d/m/Y')} - ${moment(row.to).formatPHP('d/m/Y')}`;
                            if(row.extend_date) {
                                string += ` <span>(${moment(row.extend_date).formatPHP('d/m/Y')})</span>`
                            }
                        }else{
                            string = `<s>${moment(row.from).formatPHP('d/m/Y')} - ${moment(row.to).formatPHP('d/m/Y')}</s>`;
                            if(row.extend_date) {
                                string += ` <s><span>(${moment(row.extend_date).formatPHP('d/m/Y')})</span></s>`
                            }
                            string += ` (zwrot: ${moment(row.expiry_date).formatPHP('d/m/Y')})`;
                        }


                        return string;
                    }
                },
                {
                    targets: AUTHORIZATIONS_CREATED_AT_INDEX,
                    data: 'created_at',
                    render: (data) => {
                        return moment(data).formatPHP('d/m/Y H:i:s');
                    }
                },
                {
                    targets: AUTHORIZATIONS_ACTIONS_INDEX,
                    data: null,
                    render: (data, type, row) => {
                        let buttons = [];
                        if(row.deleted_at === null && row.expiry_date === null) {
                            if(!window._is_archival_season) {
                                buttons = [...buttons,
                                    `
                                        <div class="btn-group">
                                            <a class="btn btn-sm btn-primary mb-1" href="${url(`app/authorizations/${row.id}/edit`)}">
                                                Edytuj
                                            </a>
                                        <button type="button"
                                                class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split mb-1"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                            <span class="visually-hidden">Toggle Dropdown</span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-lg-end">
                                            <li>
                                                <form class="returnAuthorizationForm" method="post" action="${url(`api/authorizations/return`)}">
                                                ${tokenInput()}
                                                    <input type="hidden" name="id" value="${row.id}">
                                                    <button class="dropdown-item">
                                                        Zwróć
                                                    </button>
                                                </form>
                                            </li>
                                            <li>
                                                <form class="deleteAuthorizationForm" method="post" action="${url(`api/authorizations/delete`)}">
                                                ${tokenInput()}
                                                    <input type="hidden" name="id" value="${row.id}">
                                                    <button class="dropdown-item">
                                                        Usuń
                                                    </button>
                                                </form>
                                            </li>
                                        `
                                ]
                            }
                        }

                        return `<span class="text-nowrap">${buttons.join('')}</span>`
                    }
                }

            ];

            return columns;
        }

        authorizationsTable.DataTable({
            deferRender: true,
            data: window._authorizations,
            stateSave: false,
            drawCallback: function () {
                this.$('.btnSendMail').each(function () {
                    new bootstrap.Tooltip($(this).closest('span')[0]);
                })
            },
            filters: {
                columns: [
                    {
                        index: AUTHORIZATIONS_DISTRICT_INDEX,
                    },
                    {
                        index: AUTHORIZATIONS_TYPE_INDEX
                    },
                    {
                        index: AUTHORIZATIONS_DATES_INDEX,
                        title: 'Data',
                        values: [
                            {
                                text: 'bieżące',
                                value: 'bieżące',
                                custom: (settings, data) => {
                                    data = data[5];

                                    let dateTo;

                                    if (data.includes('(')) {
                                        dateTo = moment(data.split('(')[1].split(')')[0], 'DD/MM/YYYY');
                                    } else {
                                        dateTo = moment(data.split(' - ')[1], 'DD/MM/YYYY');
                                    }
                                    let dateFrom = moment(data.split(' - ')[0], 'DD/MM/YYYY');
                                    let now = moment();


                                    return dateFrom.isSameOrBefore(now) && dateTo.isSameOrAfter(now);
                                }
                            },
                            {
                                text: 'nadchodzące',
                                value: 'nadchodzące',
                                custom: (settings, data) => {
                                    data = data[5];

                                    let dateFrom = moment(data.split(' - ')[0], 'DD/MM/YYYY');
                                    let now = moment();

                                    return dateFrom.isAfter(now);
                                }
                            },
                            {
                                text: 'zakończone',
                                value: 'zakończone',
                                custom: (settings, data) => {
                                    data = data[5];

                                    let dateTo;
                                    if (data.includes('(')) {
                                        dateTo = moment(data.split('(')[1].split(')')[0], 'DD/MM/YYYY');
                                    } else {
                                        dateTo = moment(data.split(' - ')[1], 'DD/MM/YYYY');
                                    }

                                    let now = moment();

                                    return dateTo.isBefore(now);
                                }
                            }
                        ]
                    }
                ]
            },
            rowCallback: (row, data) => {
                if(data.deleted_at) {
                    $(row).addClass('authorization-deleted');
                }
            },
            columnDefs: generateColumnDefs(),
            order: [[AUTHORIZATIONS_CREATED_AT_INDEX, 'desc'], [AUTHORIZATIONS_NUMBER_INDEX, 'desc']],
        });
    }

    $("#membersList").DataTable({
        order: [2, 'asc'],
        stateSave: false,
        pageLength: -1,
        columnDefs: [
            {
                targets: [1, 2],
                type: 'polstring',
            }
        ]
    });

    if ($("#membersList").length > 0) {

        body.on('change', '#membersList tbody input[type="checkbox"]', function () {
            let row = getClosestRow(this);

            if (row.hasClass('fw-bold') && !$(this).prop('checked')) {
                row.removeClass('fw-bold');
            }

            if (!row.hasClass('fw-bold') && $(this).prop('checked')) {
                row.addClass('fw-bold');
            }

            findInTableRow(row, 'input[type="text"]').attr('disabled', !$(this).prop('checked'))
        })

        $("#addAuthorization, #addExtendedAuthorization").submit(function (e) {
            e.preventDefault();

            let manyDistrictInput = $('#hasManyDistricts');
            let hasManyDistricts = manyDistrictInput.val();
            let numberingMode = parseInt(manyDistrictInput.data('numbering_mode'));

            let manyDistrictsManual = false;
            if(hasManyDistricts > 0 && numberingMode === 2){
                manyDistrictsManual = true;
            }
            let inputs = $("#membersList").DataTable().$('input');
            $('input.input__name').attr('name', '__number[]');

            let canProgress = true;

            // Wszystkie inputy znajdujące się w tabeli dodaję ponownie do tabeli jako ukryte
            // żeby mieć pewność, że każdy wypełniony input wyśle się w formularzu.
            // Jest to ważne, bo jak np. wypełni się input na 1 stronie tabeli i zmieni stronę na 2,
            // to z tabeli znika ten input z 1 strony (tabela się renderuje dynamicznie)
            for (let input of inputs) {
                let readonly = $(input).data('readonly') ?? false;

                // Sprawdzamy czy input jest aktywny
                if ($(input).attr('disabled')) {
                    continue;
                }

                if (readonly) {
                    continue;
                }
                if(manyDistrictsManual === false) {
                    if ($(input).val() === "" || $(input).val() === null) {
                        if ($(input).parent().find('span.text-danger').length === 0) {
                            $(input).parent().append('<span class="text-danger fw-normal">Wprowadź numer upoważnienia</span>');
                        }
                        canProgress = false;
                        enableFormBack();

                        continue;
                    }
                }else{
                    if($(input).data('district_id') && ($(input).val() === null || $(input).val() === '') && $(input).closest('tr').find('input[type="checkbox"]').prop('checked')){
                        if ($(input).parent().find('span.text-danger').length === 0) {
                            $(input).parent().append('<br><span class="text-danger fw-normal" style="font-size:0.8em;">Wprowadź numery upoważnień</span>');
                        }
                        canProgress = false;
                        enableFormBack();

                        continue;
                    }
                }

                // Jeśli input to checkbox (dla numeracji automatycznej są to checkboxy, dla ręcznej inputy tekstowe)
                // to sprawdzam czy jest zaznaczony oraz czy ma jakąś wartość (aby nie wysyłać checkboxa 'check-all')
                if(manyDistrictsManual === false) {
                    if ($(input).attr('type') === 'checkbox') {
                        if ($(input).prop('checked') === true) {
                            $(this).append(`<input type="hidden" name="number[${$(input).val()}]" value="${$(input).val()}" />`);
                        }
                    } else {
                        $(this).append(`<input type="hidden" name="number[${$(input).data('user_id')}]" value="${$(input).val()}" />`);
                    }
                }else{
                    if($(input).hasClass('multiAuthNumbersData') && $(input).val() !== '') {
                        input = $(input);
                        if(input.closest('tr').find('input[type="checkbox"]').prop('checked') === true) {
                            $(this).append(`<input type="hidden" name="multipleAuthNumbers[${input.data('district_id')}][${input.data('user_id')}]" value="${input.val()}" />`);
                        }
                    }
                }
            }

            if (!canProgress) {
                return;
            }
             this.submit();
        })
    }

    let animalsListTable = $("#animalsList").DataTable({
        stateSave: false
    });

    animalsListTable.DataTable().$('input[type="checkbox"]').change(function () {

        let input = $(this).closest('tr').find('input[type="number"]');
        let row = $(this).closest('tr');

        if (row.hasClass('fw-bold') && !$(this).prop('checked')) {
            row.removeClass('fw-bold');
        }
        if (!row.hasClass('fw-bold') && $(this).prop('checked')) {
            row.addClass('fw-bold');
        }

        input.attr('disabled', !$(this).prop('checked'));

        if ($(this).prop('checked')) {
            if (input.val() === "") {
                input.val(1);
            }
        }

    })

    animalsListTable.DataTable().$('[data-bs-toggle="tooltip"]').each(function () {
        new bootstrap.Tooltip(this);
    })

    if (animalsListTable.length > 0) {
        $("#addExtendedAuthorization, #editExtendedAuthorization, #editAnimalsTemplate").submit(function (e) {
            e.preventDefault();

            let inputs = animalsListTable.DataTable().$('input');
            $('input.input__animals').attr('name', '__animals[]');

            for (let input of inputs) {
                let readonly = $(input).data('readonly') ?? false;

                // Sprawdzamy czy input jest aktywny
                if ($(input).attr('disabled')) {
                    continue;
                }

                if (readonly) {
                    continue;
                }

                if ($(input).val() === "") {
                    continue;
                }

                $(this).append(`<input type="hidden" name="animals[${$(input).data('animal_id')}]" value="${$(input).val()}" />`);
            }

            this.submit();
        })

        // Zapisywanie zwierząt do szablonu
        $(animalsListTable).find('tbody input[type="checkbox"]').change(function () {
            let inputs = animalsListTable.DataTable().api().checkedCheckboxes();
            if (inputs.length > 0) {
                $("#btnSaveTemplate").attr('disabled', false);
            } else {
                $("#btnSaveTemplate").attr('disabled', true);
            }
        })

        handleApiForm('#addAnimalsTemplate', ({response, form}) => {
            if (response.data.code === 200) {
                let modalInstance = bootstrap.Modal.getInstance(document.getElementById("addTemplateModal"));
                modalInstance.hide();

                toastAlert('Pomyślnie utworzono szablon na podstawie aktualnie wybranej puli zwierząt');
                $(form).find('input[name="name"]').val("");

                if (pathIs('/app/authorizations/settings')) {
                    window.location.reload();
                }
            }
        }, () => {
            return new Promise(resolve => {
                let animals = animalsListTable.DataTable().$('input[type="number"]:not(:disabled)');

                animals.each(function () {
                    $(".animals-inputs").append(`
                        <input type="hidden" name="${`animals[${$(this).data('animal_id')}]`}" value="${$(this).val()}" />
                    `);

                    $(this).attr('name', '__animals');
                })

                resolve();
            })
        });

        // Ładowanie zwierząt z szablonu
        let loaded = false;
        $("#btnLoadFromTemplate, #btnLoadAllTemplates").click(async function () {
            let query = '';
            if ($(this).attr('id') === 'btnLoadFromTemplate') {
                query = '?district_id=' + $('input[name="district_id"]').val();

                if (loaded) {
                    return;
                }
            }
            let spinner = new Spinner();

            try {
                let response = await axios.get(url('api/authorizations/animal-templates' + query))
                spinner.destroy();

                if (response.data.code !== 200) {
                    closeModal('loadFromTemplate');
                    toastAlert('Wystąpił błąd podczas próby załadowania dostępnych szablonów. Spróbuj ponownie później.', {type: "warning"})
                    return;
                }

                let modal = $("#loadFromTemplate");
                let modalBody = modal.find('.modal-body');

                if ($(this).attr('id') === 'btnLoadFromTemplate') {
                    loaded = true;
                } else {
                    $(this).remove();
                }

                if (response.data.templates.length === 0) {
                    modalBody.html('Brak dostępnych szablonów.');
                    return;
                }

                let table = $("<table class='table w-100' />");
                modalBody.html(table);
                let thead = $('<thead />')
                table.append(thead);
                thead.append('<tr><th class="w-50">Nazwa</th><th data-orderable="false">Akcja</th></tr>');

                let tbody = $('<tbody />');
                table.append(tbody);

                let sum = 0;
                let counter = 1;

                for (let template of response.data.templates) {
                    let button = $(`<button class="btn btn-sm btn-primary me-2 mb-2">Załaduj</button>`);
                    button.click(async function () {
                        let confirm = await confirmModal('Czy na pewno chcesz załadować zwierzęta z szablonu? Wszystkie dokonane zmiany zostaną nadpisane.');
                        if (confirm) {
                            closeModal(modal);

                            let inputs = animalsListTable.DataTable().$('input');

                            //musi być osobno ponieważ w kolejnej pętli łapie tylko 1 stronę
                            for (let input of inputs) {
                                input = $(input);
                                input.prop('checked', false);
                                input.trigger('change');
                                input.val('');
                            }

                            for (let input of inputs) {
                                input = $(input);
                                let id = input.data('animal_id');
                                let animal = template.animals.find(animal => parseInt(animal.id) === id);

                                //sprawdzanie czy nie jest za dużo zwierzyny w szablonie
                                if (animal && (counter % 2 === 0) && sum < 15) {
                                    if (parseInt(animal.type.is_big) === 0) {
                                        sum += 1;
                                    } else {
                                        sum += parseInt(animal.pivot.quantity);
                                    }
                                }

                                if (sum > 15 && animal) {
                                    let diff = sum - 15;
                                    animal.pivot.quantity -= diff;
                                    toastAlert('Przekroczono dozwoloną liczbę zwierzyny na upowaznieniu, nie załadowano pełnego szablonu', {type: 'danger'});
                                }

                                if (input.attr('type') === 'checkbox') {
                                    if (animal) {
                                        input.prop('checked', true);
                                        input.trigger('change');
                                    }
                                } else if (input.attr('type') === 'number') {
                                    if (animal) {
                                        input.val(animal.pivot.quantity);
                                    }
                                }
                                if (sum > 15) {
                                    break;
                                } else if (sum === 15) {
                                    toastAlert('Przekroczono dozwoloną liczbę zwierzyny na upowaznieniu, nie załadowano pełnego szablonu', {type: 'danger'});
                                    break;
                                }
                                counter++;
                            }

                            for (let animal of template.animals) {
                                if (animal.is_remaining === false) {
                                    toastAlert('Zwierzyna ' + animal.display_name + ' nie została dodana z szablonu, ponieważ nie ma jej na liście dostępnej zwierzyny', {type: 'danger'});
                                }
                            }
                        }
                        sum = 0;
                        counter = 1;
                    })

                    let previewButton = $(`<button data-bs-toggle="modal"
                                data-bs-target="#previewTemplate" class="btn btn-sm btn-primary me-2 mb-2">Podgląd</button>`);
                    previewButton.click(function () {
                        let modal = $("#previewTemplate");

                        let modalInstance = bootstrap.Modal.getInstance(modal[0]);
                        if (modalInstance) {
                            $(modalInstance._backdrop).css('z-index', 1062);
                            $(modalInstance._element).css('z-index', 1063);
                        }

                        let modalBody = modal.find('.modal-body');
                        modal.find('#previewTitle').text(template.name);

                        let table = $("<table class='table' />");
                        modalBody.html(table);
                        let thead = $('<thead />')
                        table.append(thead);
                        thead.append('<tr><th>Zwierzyna</th><th>Liczba sztuk</th></tr>');

                        let tbody = $('<tbody />');
                        table.append(tbody);

                        for (let animal of template.animals) {
                            tbody.append(`<tr><td>${animal.display_name}</td><td>${animal.pivot.quantity}</td></tr>`);
                        }
                    })

                    let row = $('<tr />');
                    let deleteButton = $(`<button class="btn btn-sm btn-danger me-2 mb-2">Usuń</button>`);
                    deleteButton.click(async function () {
                        let confirm = await confirmModal('Czy na pewno chcesz usunąć ten szablon?');
                        if (confirm) {
                            let form = new FormData();
                            form.append('id', template.id);

                            try {
                                let response = await axios.post(url('app/authorizations/animal-templates/delete'), form);
                                if (response.data.code !== 200) {
                                    toastAlert('Nie udało się usunąć szablonu. Spróbuj ponownie później.', {type: 'danger'});
                                    return;
                                }

                                row.remove();
                                toastAlert('Pomyślnie usunięto szablon zwierzyny.');
                            } catch (err) {
                                toastAlert('Nie udało się usunąć szablonu. Spróbuj ponownie później.', {type: 'danger'});
                            }
                        }
                    })

                    row.append(`<td>${template.name}</td>`);

                    let buttonsCell = $('<td />');
                    buttonsCell.append(previewButton);
                    buttonsCell.append(button);
                    buttonsCell.append(deleteButton);
                    row.append(buttonsCell);

                    tbody.append(row);
                }

                dt_simple(table);
            } catch (err) {
                spinner.destroy();
                closeModal('loadFromTemplate');
                toastAlert('Wystąpił błąd podczas próby załadowania dostępnych szablonów. Spróbuj ponownie później.', {type: "warning"})
            }
        })
    }

    // let animalsSummaryTable = $("#animalsTableSummary");
    // if (animalsSummaryTable.length > 0) {
    //     new $.fn.dataTable.Summary(animalsSummaryTable, {
    //         column: 3
    //     });
    // }

    // Wypełnianie modala z informacjami o zwierzynie
    body.on('click', '.btnAnimalsModal', async function () {
        let modal = $("#animalsModal");
        let modalBody = modal.find('.modal-body');
        let withAnimalsLeft = false;

        let animals = $(this).data('animals');
        let number = $(this).data('number');

        if (typeof animals == 'string') {
            let spinner = new Spinner();

            try {
                let url = $(this).data('animals');
                let response = await axios.get(url);

                if (parseInt(response.data.code) !== 200) {
                    throw new Error();
                }

                spinner.destroy();

                animals = response.data.animals;
                number = response.data.number;
                withAnimalsLeft = true;

                console.log('x')
            } catch (err) {
                spinner.destroy();
                toastAlert('Nie udało się wczytać zwierzyny', {type: 'danger'})

                return;
            }
        }

        if (animals.length === 0) {
            modalBody.html('Brak wybranej zwierzyny');
            return;
        }

        let table = $("<table class='table' />");
        modalBody.html(table);
        let thead = $('<thead />')
        table.append(thead);
        thead.append(`<tr><th>Zwierzyna</th><th>Liczba sztuk</th>${withAnimalsLeft && '<th>Pozostało</th>'}</tr>`);

        let tbody = $('<tbody />');
        table.append(tbody);

        for (let animal of animals) {
            tbody.append(`<tr><td>${animal.display_name}</td><td>${animal.pivot.quantity}</td>${withAnimalsLeft && `<td>${animal.left}</td>`}</tr>`);
        }

        modal.find("#number").text('(' + number + ')');
    })


    if (authorizationsTable.length > 0) {
        authorizationsTable.on('check-all.changed', function (e, any) {
            $("#btnExtendSelected").attr('disabled', !any);
            $("#btnDeleteSelected").attr('disabled', !any);
            $("#btnSelectedToPdf").attr('disabled', !any);
            $("#btnReturnSelected").attr('disabled', !any);
            $("#btnGroupEmailSend").attr('disabled', !any);
        })

        // Generowanie wydruku zbiorowego
        $("#btnSelectedToPdf").click(async function (e) {
            e.preventDefault();

            let spinner = new Spinner(null, 'Trwa generowanie wydruku zbiorowego');

            try {
                let ids = '?';
                let i = 0;
                for (let input of authorizationsTable.DataTable().api().checkedCheckboxes()) {
                    if (i !== 0) {
                        ids += '&';
                    }

                    ids += "id[]=" + $(input).val();
                    i++;
                }

                let response = await axios.get(`${url('app/authorizations/group-pdf')}${ids}`, {
                    responseType: 'blob'
                });
                spinner.destroy();

                FileDownload(response.data, 'Upowaznienia.pdf');

            } catch (err) {
                console.log(err)
            }
        })

        // Przedłużanie ważności upoważnień
        handleApiForm("#extendAuthorizationDate", ({response}) => {
            if (response.data.code === 200) {
                window.location.reload();
            }
        }, (form) => {
            return new Promise(resolve => {
                let inputs = authorizationsTable.DataTable().$('input[type="checkbox"]');
                for (let input of inputs) {
                    if ($(input).prop('checked')) {
                        form.append(`<input type="hidden" name="authorizations[]" value="${$(input).val()}" />`);
                    }
                }

                resolve();
            })
        })

        // Usuwanie upoważnień
        handleApiForm("#deleteAuthorizations", ({response}) => {
            if (response.data.code === 200) {
                if (response.data.deleted === 0) {
                    confirmModal('Nie udało się usunąć, ponieważ na wybrane upoważnienia utworzono już polowania.', {
                        title: 'Nie udało się usunąć',
                        color: 'warning',
                        showIcon: false,
                        buttons: [
                            {type: 'resolve', text: 'Ok', color: 'warning'}
                        ]
                    });
                } else {
                    window.location.reload();
                }
            }
        }, (form) => {
            return new Promise(async (resolve, reject) => {
                let confirm = await confirmModal('Czy na pewno chcesz usunąć wybrane upoważnienia?', {color: 'danger'})

                if (confirm) {
                    let inputs = authorizationsTable.DataTable().$('input[type="checkbox"]');
                    for (let input of inputs) {
                        if ($(input).prop('checked')) {
                            form.append(`<input type="hidden" name="id[]" value="${$(input).val()}" />`);
                        }
                    }

                    resolve()
                } else {
                    reject()
                }
            })
        })

        // Usuwanie jednego upoważnienia (w wierszu)
        handleApiForm(".deleteAuthorizationForm", ({response}) => {
            if (response.data.code === 200) {
                if (response.data.deleted === 0) {
                    confirmModal('Nie udało się usunąć, ponieważ na wybrane upoważnienie utworzono już polowania.', {
                        title: 'Nie udało się usunąć',
                        color: 'warning',
                        showIcon: false,
                        buttons: [
                            {type: 'resolve', text: 'Ok', color: 'warning'}
                        ]
                    });
                } else {
                    window.location.reload();
                }
            }
        }, () => {
            return new Promise(async (resolve, reject) => {
                let confirm = await confirmModal('Czy na pewno chcesz usunąć te upoważnienie?', {color: 'danger'})

                if (confirm) {
                    resolve()
                } else {
                    reject()
                }
            })
        })
    }

    $("#btnGenerateAndPrint").click(function (e) {
        e.preventDefault();
        let form = $(this).closest('form');

        form.append('<input type="hidden" name="print" value="true" />');
        form.submit();
    })

    $("#btnSaveAuthorizationSettings").click(function (e) {
        e.preventDefault();
        $(".tab-pane.active form:first-child").submit();
    })

    $(".btnAddAnimalsTemplate").click(function () {
        $($(this).data('bs-target')).find('input[name="district_id"]').val($(this).data('district_id'));
    })

    body.on('click', '.btnSendMail', async function () {
        let email = $(this).data('email');
        let id = $(this).data('id');

        if (await confirmModal(`Czy na pewno chcesz wysłać upoważnienie w wiadomości e-mail na adres <strong>${email}</strong>?`)) {
            try {
                await axios.post(url(`api/authorizations/${id}/mail`));
                toastAlert('Pomyślnie wysłano wiadomość z upoważnieniem');
            } catch (err) {
                toastAlert('Wystąpił błąd podczas próby wysłania wiadomości', {type: 'danger'})
            }
        }
    })

    if ($('.auto-numbering-options').length > 0) {
        const updateStartingIndex = () => {
            let districtNode = $('[name="district_id"]');
            let district_id = districtNode.val();
            let category = parseInt($('[name="authorization_category_id"]').val());
            let startingIndex;

            if (category === 1) {
                startingIndex = parseInt(window._startingIndexesRegular[district_id]);
            } else if (category === 2) {
                startingIndex = parseInt(window._startingIndexesSanitary[district_id]);
            }else {
                startingIndex = parseInt(window._startingIndexesBeavers[district_id]);
            }

            $('input[name="starting_index"]').val(startingIndex).change();
        }
        updateStartingIndex();

        const updateGeneratedNumberPreview = () => {
            let districtNode = $('[name="district_id"]');

            let district_id = districtNode.val();
            let districtNumber = districtNode.find('option:selected').data('number');
            let category = parseInt($('[name="authorization_category_id"]').val());
            let seasonShortName = $('[name="season_id"]').find('option:selected').data('shortname')
            let startingIndex = parseInt($('input[name="starting_index"]').val());

            let authorizationsCount;

            if (category === 1) {
                authorizationsCount = parseInt(window._authorizationsCountRegular[district_id]);
            } else if(category == 2) {
                authorizationsCount = parseInt(window._authorizationsCountSanitary[district_id]);
            } else {
                authorizationsCount = parseInt(window._authorizationsCountBeavers[district_id]);
            }

            let number = `${authorizationsCount + startingIndex}/${districtNumber}/${seasonShortName}`;
            if (category === 2) {
                number += '/S';
            }

            if (category === 3){
                number += '/B';
            }

            $('.auto-numbering-preview').text(number);
        }
        updateGeneratedNumberPreview();

        //zmiana kolejnego generowanego numeru
        $('[name="district_id"], [name="authorization_category_id"], [name="season_id"], [name="starting_index"]').change(updateGeneratedNumberPreview);
        //zmiana indeksu startowego
        $('[name="district_id"], [name="authorization_category_id"]').change(updateStartingIndex);
        $('input[name="numbering_mode"]').change(function () {
            if (parseInt($(this).val()) === 1) {
                $('.auto-numbering-options').show();
            } else {
                $('.auto-numbering-options').hide();
            }
        })
    }

    //zwrot jednego upoważnienia (w wierszu)
    handleApiForm(".returnAuthorizationForm", ({response}) => {
        if(response.data.code === 200) {
            toastAlert('Pomyślnie zwrócono upoważnienie')
            window.location.reload();
        }else{
            toastAlert('Wystąpił błąd podczas próby dokonania zwrotu')
        }
    }, () => {
        return new Promise(async (resolve, reject) => {
            let confirm = await confirmModal('Czy na pewno chcesz zwrócić te upoważnienie?', {color: 'warning'})

            if (confirm) {
                resolve()
            } else {
                reject()
            }
        })
    })

    handleApiForm(".restoreAuthorizationForm", ({response}) => {
        if(response.data.code === 200) {
            toastAlert('Pomyślnie przywrócono upoważnienie')
            window.location.reload();
        }else{
            toastAlert('Wystąpił błąd podczas próby dokonania przywrócenia')
        }
    }, () => {
        return new Promise(async (resolve, reject) => {
            let confirm = await confirmModal('Czy na pewno chcesz przywrócić te upoważnienie?', {color: 'warning'})

            if (confirm) {
                resolve()
            } else {
                reject()
            }
        })
    })

    // Zwracanie wielu upoważnień
    handleApiForm("#returnAuthorizations", ({response}) => {
        if (response.data.code === 200) {
            window.location.reload();
        }
    }, (form) => {
        return new Promise(async (resolve, reject) => {
            let confirm = await confirmModal('Czy na pewno chcesz zwrócić wybrane upoważnienia?', {color: 'warning'})

            if (confirm) {
                let inputs = authorizationsTable.DataTable().$('input[type="checkbox"]');
                for (let input of inputs) {
                    if ($(input).prop('checked')) {
                        form.append(`<input type="hidden" name="id[]" value="${$(input).val()}" />`);
                    }
                }
                resolve()
            } else {
                reject()
            }
        })
    })

    // Wysyłanie wielu upoważnień w wiadomości email
    handleApiForm("#groupEmailAuthorizations", ({response}) => {
        if (response.data.code === 200) {
            window.location.reload();
        }
    }, (form) => {
        return new Promise(async (resolve, reject) => {

            let ids = '?';
            let i = 0;
            for (let input of authorizationsTable.DataTable().$('input[type="checkbox"]')) {
                if($(input).prop('checked')) {
                    if (i !== 0) {
                        ids += '&';
                    }

                    ids += "id[]=" + $(input).val();
                }
                i++;
            }

            let response = await axios.get(`${url('app/authorizations/group-mail/no-mail-users')}${ids}`);

            let message;
            if (response.data.users.length > 0) {
                message = (`
                Niektórzy spośród wybranych użytkowników nie posiadają wprowadzonego adresu email: <br>
                <ul class="">
            `)

                for (let user of response.data.users) {
                    message += (`<li>${user}</li>`);
                }
                message += (`</ul>Czy mimo to chcesz wysłać wybrane upoważnienia?`);

            } else {
                message = 'Czy na pewno chcesz wysłać wybrane upoważnienia w wiadomościach email?';
            }

            let confirm = await confirmModal(message, {color: 'warning'})

            if (confirm) {
                let inputs = authorizationsTable.DataTable().$('input[type="checkbox"]');
                for (let input of inputs) {
                    if ($(input).prop('checked')) {
                        form.append(`<input type="hidden" name="id[]" value="${$(input).val()}" />`);
                    }
                }
                resolve()
            } else {
                reject()
            }
        })
    })



    //CASE więcej niż jeden obwód na upoważnieniu
    $("#addNextDistrict").click(function(){

        let lastAdditionalDistrict = $('select[name="district_ids[]"]').last();

        let districtSelect;
        let districtSelectOptions;
        let selectedDistrict;

        //jezeli sa juz jakies dodane obwody to stamtad biezemy opcje, jesli nie to z glownego
        if(lastAdditionalDistrict.length >= 1){
            districtSelect = lastAdditionalDistrict;
        }else {
            districtSelect = $('#addExtendedAuthorization_district_id');
        }

        districtSelectOptions = districtSelect.find("option");
        selectedDistrict = $(districtSelect).find('option:selected');

        districtSelectOptions.parent().attr('disabled', 'disabled');
        let newOptions = [];
        for (let option of districtSelectOptions){
            let opt = $(option);
            if(opt.val() !== selectedDistrict.val()) {
                newOptions.push(opt);
            }
        }

        if(newOptions.length === 1){
            $(this).hide();
        }

        let finalPlace = $('.multiple-districts');
        let column = $(`<div class="col-12 col-md-6 mb-3"></div>`)
        let box = $(`<div class="box box-primary"></div>`);
        let newDistrictBody = $(`
            <div class="row g-3">
                    <div class="col-12">
                        <label>Obwód łowiecki</label> <br>
                        <div class="input-group">
                            <select class="form-select" name="district_ids[]"></select>
                            <button class="btn btn-danger btn-delete-extra-district" type="button" id="button-addon2">Usuń</button>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                    <label class="mb-2">Tryb numeracji: <span class="numbering-mode-text fw-normal"></span></label> <br>
                    <label>Kategoria upoważnienia: <span class="category-text fw-normal"></span></label>
                    </div>
                    <div class="col-12 col-sm-6 auto-numbering-options text-sm-end text-start">
                        <div class="row g-3">
                            <div class="col-12">
                                <label>Kolejny generowany numer</label><br />
                                <span class="auto-numbering-preview-additional"></span>
                            </div>
                            <div class="col-12">
                                <label for="starting_index_additional">Indeks startowy</label>
                                <input type="number" class="form-control form-control-sm starting_index_additional" name="starting_indexes[]">
                            </div>
                        </div>
                    </div>
                </div>
        `)

        let select = newDistrictBody.find('select[name="district_ids[]"]');
        for(let option of newOptions){
            let opt = $(`<option value="${option.val()}" data-number="${option.data('number')}">${option.html()}</option>`)
            select.append(opt);
        }

        let district_id = select.find('option:selected').val();
        let startingIndex;

        box.append(newDistrictBody);
        column.append(box);
        finalPlace.append(column);

        let categoryInput = $('[name="authorization_category_id"]');
        let category = parseInt(categoryInput.val());
        let categoryText = $('.category-text');
        if (category === 1) {
            categoryText.html('Standardowe');
            startingIndex = parseInt(window._startingIndexesRegular[district_id]);
        } else if(category === 2) {
            categoryText.html('Sanitarne');
            startingIndex = parseInt(window._startingIndexesSanitary[district_id]);
        }else{
            categoryText.html('Upoważnienie na bobry');
            startingIndex = parseInt(window._startingIndexesBeavers[district_id]);
        }

        let numberingMode;
        if(!document.getElementById('addExtendedAuthorization_numbering_mode_1').checked){
            $('.auto-numbering-options').hide();
            numberingMode = 2;
        }else{
            numberingMode = 1;
        }

        let starting_index = box.find('.starting_index_additional');
        starting_index.val(startingIndex);

        starting_index.change(function(){
            let that = $(this);
            let boxNode = that.closest('.box');
            let districtNode = boxNode.find($('[name="district_ids[]"]'));
            let district_id = districtNode.val();
            let districtNumber = districtNode.find('option:selected').data('number');
            let category = parseInt($('[name="authorization_category_id"]').val());
            let seasonShortName = $('[name="season_id"]').find('option:selected').data('shortname');
            let startingIndex = parseInt(that.val());

            let authorizationsCount;

            if (category === 1) {
                authorizationsCount = parseInt(window._authorizationsCountRegular[district_id]);
            } else if(category === 2) {
                authorizationsCount = parseInt(window._authorizationsCountSanitary[district_id]);
            } else{
                authorizationsCount = parseInt(window._authorizationsCountBeavers[district_id]);
            }

            let number = `${authorizationsCount + startingIndex}/${districtNumber}/${seasonShortName}`;
            if (category === 2) {
                number += '/S';
            }

            if (parseInt(category) === 3) {
                number += '/B';
            }

            boxNode.find('.auto-numbering-preview-additional').text(number);
            let numberingModeText = boxNode.find('.numbering-mode-text');
            if(numberingMode === 1){
                numberingModeText.html('Automatyczny');
            }else{
                numberingModeText.html('Ręczny');
            }

        })
        starting_index.change();

        select.change(function(){
            let that = $(this);
            let district_id = that.find('option:selected').val();
            let starting_index = that.closest('.box').find('.starting_index_additional');

            let category = parseInt($('[name="authorization_category_id"]').val());

            if(category === 1) {
                starting_index.val(parseInt(window._startingIndexesRegular[district_id]));
            }else if(category === 2){
                starting_index.val(parseInt(window._startingIndexesSanitary[district_id]));
            }else{
                starting_index.val(parseInt(window._startingIndexesBeavers[district_id]));
            }
            starting_index.trigger('change');
        })

        $('[name="season_id"]').change(function (){
            $('.starting_index_additional').change();
        })

        categoryInput.change(function(){
            $('select[name="district_ids[]"]').change();
            let categoryText = $('.category-text');
            if(parseInt(categoryInput.val()) === 1){
                categoryText.html('Standardowe');
            }else if (parseInt(categoryInput.val()) === 2){
                categoryText.html('Sanitarne');
            }else{
                categoryText.html('Upoważnienie na bobry');
            }
        })

        $('.btn-delete-extra-district').click(function () {

            $("#addNextDistrict").show();
            let that = $(this);
            let boxNode = that.closest('.box');
            // let boxNode = that.parent().parent().parent().parent();
            let selectToDelete = boxNode.find('select');
            let selectedOption = selectToDelete.find('option:selected');
            boxNode.parent().remove();
            let selects = $('select[name="district_ids[]"]');

            if(selects.length > 0){
                selects.last().removeAttr('disabled');
            }else{
                $('select[name="district_id"]').removeAttr('disabled');
            }

            let option = $(`<option value="${selectedOption.val()}" data-number="${selectedOption.data('number')}">${selectedOption.html()}</option>`);
            for (let select of selects){
                select = $(select);
                let options = select.find('option');
                let is_duplicate = false;
                for (let opt of options){
                    opt = $(opt);
                    if(opt.val() === option.val()){
                        is_duplicate = true;
                    }
                }
                if(is_duplicate === false) {
                    select.append(option);
                }
            }
        })

        $('input[name="numbering_mode"]').change(function () {
            if (parseInt($(this).val()) === 1) {
                numberingMode = 1;
            } else {
                numberingMode = 2;
            }

            let numberingModeTexts = $('.numbering-mode-text');

            for(let content of numberingModeTexts){
                content = $(content);
                if(numberingMode === 1){
                    content.html('Automatyczny');
                }else{
                    content.html('Ręczny');
                }
            }

        })

        $('#addExtendedAuthorization').submit(function() {
            $('select').removeAttr('disabled');
        })

    })

    let dataForExtraDistricts = window._dataForExtraDistricts ?? [];

    for (const district in dataForExtraDistricts){
        let btn = $('#addNextDistrict');
        btn.trigger('click');
        let lastAdditionalDistrict = $('select[name="district_ids[]"]').last();
        let boxNode = lastAdditionalDistrict.closest('.box');
        boxNode.find('select').val(district).change();
    }

    if (pathIs('/app/authorizations/add-2')) {

        let checkbox = $('input.input__name');
        checkbox.change(function(){
            let btn = $(this).closest('tr').find('.openAuthModal');
            if($(this).prop('checked')){
                btn.removeAttr('disabled');
                let tr = btn.closest('tr');
                let inputs = tr.find('input[type="hidden"]');
                for(let input of inputs){
                    input = $(input);
                    if(input.val() === '' || input.val() === null){
                        btn.removeClass('btn-primary');
                        btn.addClass('btn-warning');
                    }
                }
            }else{
                btn.attr('disabled', 'disabled');
                btn.removeClass('btn-warning');
                btn.addClass('btn-primary');
            }
        })

        let btns = $('.openAuthModal');
        for(let btn of btns){
            btn = $(btn);
            let tr = btn.closest('tr');
            let checkbox = tr.find('input[type="checkbox"]');
            if(checkbox.prop('checked')) {
                btn.removeAttr('disabled');

                let authNumbers = tr.find('input[type="hidden"]');
                for (let number of authNumbers) {
                    if ($(number).val() === '' || $(number).val() === null) {
                        btn.toggleClass('btn-primary');
                        btn.toggleClass('btn-warning');
                    }
                }
            }

        }

        $(".openAuthModal").click(function (){
            let modalNode = $('#authNumbersModal');
            let user_id = $(this).data('user_id');
            modalNode.find('#user_id').val(user_id);

            let inputs = $(this).closest('td').find('input[type="hidden"]');
            for(let input of inputs){
                input = $(input);
                let district_id = input.data('district_id');
                modalNode.find(`input[data-district_id="${district_id}"]`).val(input.val());
            }

        })

        $(".btnSaveAuths").click(function(){
            let modalNode = $('#authNumbersModal');
            let inputs = modalNode.find('input[type="text"]');

            let numbers = [];

            for (let input of inputs) {
                input = $(input);

                let district_id = input.data('district_id');
                let number = input.val();
                let user_id = modalNode.find('#user_id').val();
                let name = "authNumbers[" + district_id + "]" + "[" + user_id + "]";
                let final_input = $(`input[name="${name}"]`);
                final_input.val(number);
                numbers.push(final_input);
            }

            let toChange = false;
            for(let number of numbers){
                number = $(number);
                if(number.val() === '' || number.val() === null){
                    toChange = true;
                }
            }

            let btn = $(numbers[0]).closest('tr').find('.openAuthModal');
            if(toChange === true){
                btn.addClass('btn-warning');
            }else{
                btn.removeClass('btn-warning');
                btn.addClass('btn-primary');
            }

            closeModal(modalNode);
        })

    }

    $(".simpleAuthNumbersTable").DataTable({
        order: [1, 'asc'],
        stateSave: false,
        columnDefs:[
            {
                targets: [0, 1],
                type: 'polstring',
            }
        ]
    });

    let membersListTable = $('#membersList');
    $('.type__filter').change(function(){
        let that = $(this);
        let id = that.val();
        if(that.is(':checked')) {
            membersListTable.find(`tr[data-type_id=${id}]`).show();
        }else{
            membersListTable.find(`tr[data-type_id=${id}]`).hide();
        }
    })



}
